import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "./ui";
import { api } from "../services";
import { useTranslation } from "react-i18next";
import logo from "../assets/logos/logo.png";
import AuthPageLayout from "./AuthPageLayout";

function ForgotPassword() {
  const { t } = useTranslation("translation");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");
    setError("");
    try {
      const response = await api.post("/forgot-password", { email });
      setMessage(
        response.data.message ||
          t("forgotPassword.sent", {
            defaultValue: "If an account exists, a reset link has been sent.",
          })
      );
    } catch (err) {
      setError(
        err.response?.data?.message ||
          t("An error occurred.", { defaultValue: "An error occurred." })
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthPageLayout>
      <div className="auth-page-card__logo">
        <img src={logo} alt="Loops" />
      </div>
      <h1 className="auth-page-card__title">
        {t("Forgot Password", { defaultValue: "Forgot Password" })}
      </h1>
      <p className="auth-page-card__subtitle">
        {t("forgotPassword.subtitle", {
          defaultValue: "Enter your email and we’ll send you a reset link.",
        })}
      </p>

      <form className="auth-form" onSubmit={handleForgotPassword} noValidate>
        <div className="auth-field">
          <input
            id="forgot-email"
            type="email"
            autoComplete="email"
            placeholder={t("Email address")}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        {message ? <p className="auth-form-success">{message}</p> : null}
        {error ? <p className="auth-form-error">{error}</p> : null}

        <Button
          type="submit"
          color="primary"
          size="md"
          className="auth-submit"
          disabled={loading}
        >
          {loading
            ? t("Sending...", { defaultValue: "Sending..." })
            : t("Send Reset Link", { defaultValue: "Send Reset Link" })}
        </Button>
      </form>

      <div className="auth-links-row" style={{ justifyContent: "center" }}>
        <Link to="/" className="auth-link-primary">
          {t("accountCreated.backToLogin", { defaultValue: "BACK TO LOGIN" })}
        </Link>
      </div>
    </AuthPageLayout>
  );
}

export default ForgotPassword;
